/// <reference path="../_all.ts" />

module shoppinglist {
  'use strict';
  
  AddToCartButtonDirective.$inject = ['shoppingListService', '$timeout'];
  export function AddToCartButtonDirective(shoppingListService : ShoppingListService, $timeout: ng.ITimeoutService): ng.IDirective {

      return {
        restrict: 'EA'
        , scope : {
          partid : "@"
          , btnClass : "@"
          , listtype : "@"
          , qty : "@"
          , tooltip : "@"
          , requestOnGoing : "="
        }
        , transclude: true
        , templateUrl : 'shoppinglist/AddToCartButtonDirective'
        , link: function(scope : IAddToCartDirectiveScope, element: JQuery, attr: ng.IAttributes ) {
          
            scope.addToCart = function() {
              scope.requestOnGoing = true;
              shoppingListService.addToList(scope.partid, scope.listtype, scope.qty, (data) => { 
	              scope.requestOnGoing = false;
                scope.success = true;
                $timeout(() => {
                  scope.success = false;
                }, 1500);
              });
            }

        }
    };
  }
}


